import React, {Suspense} from "react"
import SuspenseFallback from "./Components/SuspenseFallback/SuspenseFallback"


const wrapInSuspense = (comp, key) => (<Suspense key={key} fallback={<SuspenseFallback />}>
	{comp}
</Suspense>)

export default wrapInSuspense
